define(function (require) {
    "use strict";
    var LE = require("app");
    var InlineInput = require("ui/inline-input/InlineInput");
    var Dropdown = require("ui/dropdown/Dropdown");
    var Bubble = require("ui/bubble/Bubble");
    var ScheduleUtilities = require("utils/ScheduleUtilities");
    var DateUtility = require("utils/DateUtility");
    var SpecialOccasionShiftsListView = require("manager-views/special-occasion/SpecialOccasionShiftsListView");
    var SpecialOccasionEventModel = require("models/entities/scheduling/SpecialOccasionEventModel");
    var Config = require("manager-assets/config/config.json");

    var template = require("manager-templates/special-occasion/specialOccasionEventsTableRowView.tmpl");

    var EVENT_TYPES_ORDER = [ScheduleUtilities.EVENT_TYPES.ALL_HOURS, ScheduleUtilities.EVENT_TYPES.INACTIVE, ScheduleUtilities.EVENT_TYPES.CUSTOM];

    var SpecialOccasionEventsTableRowView = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        SpecialOccasionEventsTableRowView = Marionette.ItemView.extend({
            template: template,
            tagName: "tr",
            className: "special-occasion-row",
            ui: {
                nameContainer: ".name-input-container",
                timeFrameCell: ".special-occasion-cell.time-frame",
                nameCell: ".special-occasion-cell.name",
                timeFrameContainer: ".time-frame-container",
                timeFrameLabel: ".time-frame-container .time-frame-label",
                shiftStatusContainer: ".shift-status-container",
                shiftTimeContainer: ".shift-time-container",
                garbageCan: ".garbage-can"
            },
            uiComponents: {
                name: {
                    type: InlineInput,
                    options: {
                        permutation: InlineInput.PERMUTATION.J,
                        container: "view.ui.nameContainer",
                        value: "view._getEventName",
                        maxLength: Config.validators.specialOccasions.event.maxNameLength,
                        autoFocus: "view.model.isNew",
                        placeholder: LE.translator.translate("LEManager.specialOccasionEditView.eventsTable.name.placeholder")
                    },
                    events: {
                        change: "_onNameInputChange",
                        blur: "_onNameInputBlur"
                    }
                },
                shiftType: {
                    type: Dropdown,
                    options: {
                        container: "view.ui.shiftStatusContainer",
                        items: "view._getShiftTypes",
                        selectedOption: "view.model.getType",
                        permutation: Dropdown.PERMUTATION.XX_SMALL1,
                        testCollision: true,
                        collisionWithinSelector: ".page-inside-view-container .view-container"
                    },
                    events: {
                        "change":"_onShiftTypeChange"
                    }
                }
            },
            events: {
                "click @ui.timeFrameCell": "_onTimeFrameClick",
                "click @ui.garbageCan": "_removeEvent",
                "mouseenter @ui.timeFrameContainer": "_showTimeFrameErrorBubble",
                "mouseleave @ui.timeFrameContainer": "_closeTimeFrameErrorBubble",
            },
            modelEvents: {
                "change:name": "_updateName",
                "change:startDate": "_updateDate",
                "change:endDate": "_updateDate",
                "change:type": "_updateType"
            },

            initialize:function(options) {
                this._initialize(options);
            },

            onRender: function() {
                this._onRender();
            },

            _initialize: function(options) {
                this.channel = options.channel;
            },

            _onRender: function() {
                this._bindEvents();
                this._updateName();
                this._updateDate();
                this._renderSpecialOccasionShiftsListView();
            },

            _bindEvents: function() {
                if (this.model.isNew()) {
                    this.listenToOnce(this.model, "change:id", this._onIdChanged);
                }
            },

            _updateName: function() {
                var name = this._getEventName();
                this.uiComponents.name.setError(false);
                this.ui.timeFrameContainer.removeClass("error");
                this.uiComponents.name.setValue(name);
                this.uiComponents.name.setTooltip(name);
            },

            _updateDate: function() {
                var textToDisplay = LE.translator.translate("LEManager.specialOccasionEditView.eventsTable.timeFrame.empty");
                var displayNewLineState = true;
                if (!_.isNull(this.model.getStartDate()) && !_.isNull(this.model.getEndDate())) {
                    var startDate = DateUtility.getDateToShow(this.model.getStartDate());
                    var endDate = DateUtility.getDateToShow(this.model.getEndDate());
                    textToDisplay = startDate + " - " + endDate;
                    displayNewLineState = false;
                }
                this.ui.timeFrameContainer.toggleClass("new-line-state", displayNewLineState);
                this.ui.timeFrameContainer.removeClass("error");
                this.ui.timeFrameLabel.text(textToDisplay);
            },

            _updateType: function() {
                this.uiComponents.shiftType.setSelection(this.model.getType());
            },

            _getEventName: function() {
                return this.model.getName();
            },

            _onNameInputChange: function(componentId, eventName, value) {
                this.channel.trigger("SpecialOccasionEventsTable:change:name", this, this.model, value);
            },

            /**
             * This happens when there is an error from the server and the user enters the input (focus) and blur it without change it.
             * In this case the value in the model will be the last known good value, and the value in the ui will be the 'bad' value.
             * In this case we need to change the ui back to the last known good value.
             * The value from the model is the last known good value - handled by the controller
             * @param componentId
             * @param eventName
             * @param value
             */
            _onNameInputBlur: function(componentId, eventName, value) {
                if (value !== this.model.getName()) {
                    this.uiComponents.name.setValue(this.model.getName());
                }
            },

            _getShiftTypes: function() {
                var items = _.map(EVENT_TYPES_ORDER, function(type) {
                    return {
                        key: type,
                        value: LE.translator.translate("LEManager.scheduleEditView.shiftStatus." + type)
                    };
                });
                return new Dropdown.Collection(items);
            },

            _onShiftTypeChange: function(componentId, eventName, value) {
                this.channel.trigger("SpecialOccasionEventsTable:change:shiftType", this.model, value.selectedKey);
                this._renderSpecialOccasionShiftsListView();
            },

            _onIdChanged: function() {
                this.channel.trigger("SpecialOccasionEventsTable:change:id");
            },

            _onTimeFrameClick: function() {
                this.channel.trigger("SpecialOccasionEventsTable:click:timeFrame", this.model, this.ui.timeFrameCell);
            },

            _removeEvent: function() {
                this.channel.trigger("SpecialOccasionEventsTable:event:remove", this.model);
            },

            _renderSpecialOccasionShiftsListView: function() {
                this._closeSpecialOccasionShiftsList(true);
                if (this.model.getType() === ScheduleUtilities.EVENT_TYPES.CUSTOM) {
                    this.uiComponents.host$.createAndRender("specialOccasionShiftsListView", {
                        type: SpecialOccasionShiftsListView,
                        options: {
                            container: "view.ui.shiftTimeContainer",
                            collection: "view._getShiftsCollection",
                            specialOccasionEventModel: "view.model",
                            channel: "view.channel"
                        }
                    });
                }
            },

            _closeSpecialOccasionShiftsList: function (force) {
                if (this.uiComponents.specialOccasionShiftsListView) {
                    this.uiComponents.specialOccasionShiftsListView.close(force);
                }
            },

            _getShiftsCollection: function() {
                return this.model.getShiftsCollection();
            },

            onValidatedInvalid: function(model, errorsObj) {
                this._clearErrors();
                if (_.has(errorsObj, SpecialOccasionEventModel.KEYS.NAME)) {
                    this.uiComponents.name.setError(true, errorsObj[SpecialOccasionEventModel.KEYS.NAME]);
                }
                if (_.has(errorsObj, SpecialOccasionEventModel.KEYS.START_DATE) || _.has(errorsObj, SpecialOccasionEventModel.KEYS.END_DATE)) {
                    this.ui.timeFrameContainer.addClass("error");
                    this.timeFrameErrorMsg = LE.translator.translate("LEFramework.entities.specialOccasion.errors.dates.required");
                }
                else {
                    if (_.has(errorsObj, "duplicate")) {
                        this.timeFrameErrorMsg = LE.translator.translate("LEFramework.entities.specialOccasion.errors.duplicate.event");
                        this.ui.timeFrameContainer.addClass("error");
                    }
                    else if (_.has(errorsObj, "inactiveDateLimit")) {
                        this.timeFrameErrorMsg = errorsObj.inactiveDateLimit;
                        this.ui.timeFrameContainer.addClass("error");
                    }
                }
            },

            _clearErrors: function() {
                this.uiComponents.name.setError(false);
                this.ui.timeFrameContainer.removeClass("error");
                this.timeFrameErrorMsg = null;
            },

            _showTimeFrameErrorBubble: function() {
                if (this.ui.timeFrameContainer.hasClass("error")) {
                    this._closeTimeFrameErrorBubble(null, true);
                    this.uiComponents.host$.createAndRender("timeFrameErrorBubble", {
                        type: Bubble,
                        options: {
                            targetControl: this.ui.timeFrameContainer,
                            position: Bubble.POSITION.BOTTOM,
                            showCloseButton: false,
                            isDelayed: true,
                            text: this.timeFrameErrorMsg
                        }
                    });
                }
            },

            _closeTimeFrameErrorBubble: function(event, force) {
                if (this.uiComponents.timeFrameErrorBubble) {
                    this.uiComponents.timeFrameErrorBubble.close(force);
                }
            }

        });
    }

    LE.module("LEManager", moduleDefinition);

    return SpecialOccasionEventsTableRowView;
});
